const formatNumber = (value: number): string => {
  const roundedValue = Math.round(value);

  if (roundedValue >= 1_000_000) {
    const millions = roundedValue / 1_000_000;
    const formattedMillions = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }).format(millions);
    return `${formattedMillions}M`;
  } else if (roundedValue >= 1_000) {
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    }).format(roundedValue);
  } else if (roundedValue >= 100) {
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(roundedValue);
  } else {
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  }
};

export default formatNumber;
